import React, { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import ErrorBoundary from './ErrorBoundary';

interface Props {
  children: ReactNode;
}

const WorkoutErrorBoundary: React.FC<Props> = ({ children }) => {
  const navigate = useNavigate();

  const handleWorkoutError = (error: Error) => {
    console.error('Workout Error:', error);
    
    // Could implement workout data recovery logic here
    // For example, auto-save current workout state to localStorage
  };

  const fallbackUI = (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-lg p-6 max-w-md w-full">
        <div className="text-center mb-4">
          <div className="text-4xl mb-2">🏋️‍♂️</div>
          <h2 className="text-xl font-bold text-gray-900 mb-2">
            Workout Session Error
          </h2>
          <p className="text-gray-600 text-sm mb-4">
            Something went wrong with your workout session. Your progress may have been saved automatically.
          </p>
        </div>

        <div className="space-y-3">
          <button
            onClick={() => navigate('/')}
            className="w-full bg-blue-600 text-white py-2 px-4 rounded-lg hover:bg-blue-700 transition-colors"
          >
            Return to Home
          </button>
          
          <button
            onClick={() => window.location.reload()}
            className="w-full bg-gray-600 text-white py-2 px-4 rounded-lg hover:bg-gray-700 transition-colors"
          >
            Restart Session
          </button>

          <div className="text-center">
            <p className="text-xs text-gray-500">
              Check your workout history to see if progress was saved
            </p>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <ErrorBoundary
      fallback={fallbackUI}
      onError={handleWorkoutError}
      context="workout session"
    >
      {children}
    </ErrorBoundary>
  );
};

export default WorkoutErrorBoundary;